import { applyStyles } from '@popperjs/core';
import http from './http';

const liffInit = (liffId, userType) => {
  // Determines whether the LIFF app is running in a LIFF browser.
  if (!liff.isInClient()) {
    return;
  }

  liff
    .init({
      liffId,
    })
    .then(async () => {
      try {
        const user_profile = await liff.getProfile();
        const line_user_id = user_profile.userId;

        // LINE login
        if (user_profile != null) {
          http.post(`/api/${userType}/line-login/`, { line_user_id }).then((res) => {
            if (!res.data) {
              return;
            }

            const data = res.data;
            if (!data.is_logged_in) {
              // in login page, set userId to form input
              document.getElementById('line_user_id').value = data.line_user_id;
            } else {
              if (!data.is_coordinated) {
                if (data.is_coordinate_success) {
                  toast('success', 'LINEと連携しました');
                  if (data.got_5000_p) {
                    setTimeout(() => {
                      toast('success', '5000Pが付与されました。');
                    }, 2000);
                  }
                } else {
                  toast('error', 'Error save Line user Id!');
                }
              }
            }
          });
        }
      } catch (error) {
        toast('error', error.message);
      }
    })
    .catch((err) => {
      console.log(err.message);
    });
};

export default liffInit;
